<template>
  <div class="p-8" v-if="loading">
    <loading />
  </div>
  <div v-else-if="helpVisible">
    <help @close="toggleHelp">
      <div class="stack-lg">
        <p>{{ $t('targets.help_message_general') }}</p>
      </div>
    </help>
  </div>
  <div v-else-if="friendSelect">
    <friends-site select :selected="formData.friends" @close="toggleFriendSelect($event)" />
  </div>
  <div class="p-6 stack" v-else>
    <div class="p-4 border border-gray-500 grid grid-cols-1-auto" v-if="selectedActivity">
      <div>{{ selectedActivity.title }}</div>
      <div>
        <wd-button transparent @input="clearSelectedActivity">
          <icon name="Edit" />
        </wd-button>
      </div>
    </div>
    <div v-else>
      <info
        class="mb-2"
        toggleable
        :title="$t('targets.create.activity_search')"
      >{{ $t("targets.create.info") }}</info>
      <input-text label="Aktivität" @update-value="searchActivity" />
      <div
        class="max-h-48 border border-gray-500 border-t-0 overflow-y-auto"
        v-if="foundActivities.length > 0 || sending || sentOnce"
      >
        <div class="w-full p-4" v-if="sending">
          <icon name="Loading" />
        </div>
        <div
          class="p-4"
          v-else-if="foundActivities.length < 1"
        >{{ $t("targets.create.no_activity_found") }}</div>
        <div v-else>
          <activity
            v-for="activity in foundActivities"
            :activity="activity"
            :category="getCategory(activity.activity_category_id)"
            :key="activity.id"
            selection
            @select="selectActivity"
          />
        </div>
      </div>
    </div>
    <input-text
      type="number"
      :label="$t('targets.target_value')"
      :value="formData.target"
      @update-value="updateForm('target', $event)"
      required
    />
    <input-date
      :label="$t('targets.start_date')"
      @update-value="updateForm('start', $event)"
      required
      :min="new Date()"
      :value="formData.start"
    />
    <input-date
      :label="$t('targets.end_date')"
      @update-value="updateForm('end', $event)"
      required
      :min="new Date()"
      :value="formData.end"
    />
    <input-check
      :label="$t('targets.group_target')"
      @update-value="updateForm('group', $event)"
      :value="formData.group"
    />
    <div class="border border-gray-500" v-if="formData.group">
      <div class="p-2" v-if="formData.friends && formData.friends.length > 0">
        <friend v-for="friend in selectedFriends" :friend="friend" :key="friend.id" />
      </div>
      <wd-button
        class="p-2 w-full text-left"
        transparent
        @input="toggleFriendSelect"
      >{{ $t('users.add_friend') }}</wd-button>
    </div>
    <div class="text-right">
      <wd-button :sending="sending" @input="sendTargetCreate">Erstellen</wd-button>
    </div>
  </div>
</template>

<script>
const Activity = require("@/modules/activities/components/Activity.vue")
  .default;
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputDate = require("@/modules/input/components/InputDate.vue").default;
const InputCheck = require("@/modules/input/components/InputCheck.vue").default;
const Friend = require("@/modules/users/components/Friend.vue").default;
const FriendsSite = require("@/modules/users/components/FriendsSite.vue")
  .default;
const Info = require("@/modules/core/components/Info.vue").default;
const Help = require("@/modules/core/components/Help.vue").default;

import { Activity as ActivityModel } from "@/modules/activities/viewmodels/Activity";
import { ActivityCategory } from "@/modules/activities/viewmodels/ActivityCategory";

import FormMixin from "@/mixins/FormMixin";
import DateMixin from "@/mixins/DateMixin";
import _ from "lodash";

export default {
  name: "TargetCreateSite",
  mixins: [FormMixin, DateMixin],
  data() {
    return {
      activityCategories: [],
      selectedFriends: [],
      friendSelect: false,
      activitySearch: "",
      foundActivities: [],
      helpVisible: false,
      selectedActivity: null,
      sentOnce: false
    };
  },
  props: {},
  components: {
    Activity,
    InputText,
    InputDate,
    InputCheck,
    Friend,
    FriendsSite,
    Info,
    Help
  },
  methods: {
    toggleFriendSelect(Friends) {
      this.friendSelect = !this.friendSelect;
      if (!this.friendSelect) this.updateHeader();
      if (Friends) {
        this.selectedFriends = Friends;
        this.updateForm(
          "friends",
          Friends.map(e => e.id)
        );
      }
    },
    updateHeader() {
      this.$store.dispatch("header/update", {
        backbutton: true,
        clear: true,
        help: () => {
          this.toggleHelp();
        },
        elements: [
          {
            value: this.$t("targets.create.create_target")
          }
        ]
      });
    },
    getCategory(Id) {
      return this.activityCategories
        ? new ActivityCategory(this.activityCategories.find(e => e.id === Id))
        : false;
    },
    searchActivity: _.debounce(function(SearchTerm) {
      if (!this.sentOnce) this.sentOnce = true;
      if (!SearchTerm) return;
      this.searchFormOptions.data = { search: SearchTerm };
      this.submit(this.searchFormOptions);
    }, 300),
    selectActivity(Activity) {
      this.selectedActivity = Activity;
      this.updateForm("activity_id", Activity.id);
    },
    clearSelectedActivity() {
      this.selectedActivity = null;
      this.updateForm("activity_id", null);
    },
    sendTargetCreate() {
      if (
        this.formData.group &&
        (!this.formData.friends || this.formData.friends.length < 1)
      ) {
        this.popup({
          type: "alert",
          title: this.$t("general.errors.request_error"),
          text: this.$t("targets.create.no_friends_chosen_group_target")
        });
        return;
      }
      this.submit(this.createTargetFormOptions);
    },
    toggleHelp() {
      this.helpVisible = !this.helpVisible;
    }
  },
  computed: {},
  async created() {
    this.activityCategories = await this.$store.getters[
      "activitycategory/api"
    ].GetAll();

    // Get route query params
    let routeQuery = this.$route.query;

    if (routeQuery.activity) {
      this.updateForm("activity_id", routeQuery.activity);
      this.selectedActivity = await this.$store.getters["activity/api"].Show(
        routeQuery.activity
      );
    }

    // Formoptions for search form
    this.searchFormOptions = {
      custom: true,
      async: true,
      type: "activity",
      call: "search",
      action: response => {
        this.foundActivities = response;
      }
    };
    this.createTargetFormOptions = {
      custom: true,
      async: true,
      type: "target",
      call: "create",
      action: response => {
        this.popup({
          type: "success",
          title: this.formData.group
            ? this.$t("targets.create.group_target_created")
            : this.$t("targets.create.target_created"),
          autoHide: true
        });
        this.goTo("/targets");
      }
    };

    this.formData.start = this.momentTodayDatePicker();
    this.updateHeader();
    this.loaded();
  }
};
</script>
